import { useState, useEffect } from 'react'
import { getRequest } from '../../../resources/api-request'
import { AddOn, PlanDetails, SelectedAddOn } from '../../../utility/subscriptionInterfaces'

interface agentDetails {
    email: string
    name: string
}

const useFetchData = (locationId: string, agentCode: string) => {
    const [isLoading, setIsLoading] = useState(true)
    const [isError, setIsError] = useState(false)
    const [planDetails, setPlanDetails] = useState<PlanDetails[]>([])
    const [addOns, setAddOns] = useState<AddOn[]>([])
    const [balance, setBalance] = useState<number>(0)
    const [agentDetails, setAgentDetails] = useState<agentDetails>({
        name: '',
        email: ''
    })

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [subscriptionResponse, balanceResponse] = await Promise.all([
                    getRequest(`reseller/subscription-summary-agent/${locationId}`),
                    getRequest(`${process.env.REACT_APP_RESELLAR_BACKEND_URL}/agent/balance?agentCode=${agentCode}`)
                ])

                const subscriptionData = subscriptionResponse?.data?.data[0] || null
                setPlanDetails(subscriptionData?.planDetails || null)
                const rawAddOns = subscriptionData?.addons || []
                setAddOns(
                    rawAddOns.map((addon: any, index: number) => ({
                        ...addon,
                        id: addon.id || addon.name || `addon-${index}`
                    }))
                )

                setBalance(balanceResponse?.data?.balance)
                setAgentDetails({ email: balanceResponse?.data?.email, name: balanceResponse?.data?.name })
            } catch (error) {
                console.error('Error fetching data:', error)
                setIsError(true)
            } finally {
                setIsLoading(false)
            }
        }

        fetchData()
    }, [locationId, agentCode])

    return { isLoading, isError, planDetails, addOns, balance, agentDetails }
}

export default useFetchData
